import { on } from "delegated-events";
import { stagger, timeline } from "motion";

const siteHeader = document.querySelector(".site-header");
const siteMenuTrigger = document.querySelector(".site-menu-trigger");
const siteMenu = document.querySelector(".site-menu");

const generateSiteMenuLinePath = () => {
  const svg = document.querySelector(".site-menu-line svg");
  const holder = document.querySelector(".site-menu-line");
  const svgRect = holder.getBoundingClientRect();

  svg.setAttribute("viewBox", `-1 -1 ${svgRect.width} ${svgRect.height}`);

  const pathParts = [`M${svgRect.width} 0`];

  let a = 70;
  let b = 80;

  if (window.matchMedia("(min-width: 1280px)").matches) {
    a = 80;
    b = 100;
  }

  pathParts.push(`H${b}`);
  pathParts.push(`C${a} 0 0 0 0 ${b}`);
  pathParts.push(`V${svgRect.height}`);

  const pathData = pathParts.join("");

  svg.innerHTML = `<path d="${pathData}" stroke="white" stroke-width="2" fill="none" stroke-dashoffset="4000" stroke-dasharray="4000" />`;
};

const openMenu = async () => {
  siteMenuTrigger.setAttribute("aria-label", "Close main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "true");
  siteMenu.setAttribute("aria-hidden", "false");
  document.documentElement.classList.add("js-menu-active");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    timeline([
      [
        ".site-menu-wrapper",
        {
          x: ["-100%", 0],
          duration: 0.75,
          ease: "expoScale(0.5, 7, none)",
        },
      ],
      [
        ".site-menu-line path",
        {
          strokeDashoffset: 0,
          duration: 12,
          easing: "linear",
        },
      ],
      [
        ".site-menu .site-menu-item",
        { y: ["60%", 0], opacity: [0, 1], duration: 0.2 },
        { delay: stagger(0.1), at: "<" },
      ],
    ]);
  }
};

const closeMenu = async () => {
  siteMenuTrigger.setAttribute("aria-label", "Open main menu");
  siteMenuTrigger.setAttribute("aria-expanded", "false");
  siteMenuTrigger.classList.add("pointer-events-none");
  siteMenu.setAttribute("aria-hidden", "true");

  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
    await timeline([
      [".site-menu .site-menu-item", { y: [0, "60%"], opacity: [1, 0], duration: 0.2 }],
      [
        ".site-menu-line path",
        {
          strokeDashoffset: 4000,
          duration: 2,
          easing: "linear",
        },
      ],
      [
        ".site-menu-wrapper",
        {
          x: [0, "-100%"],
          duration: 0.3,
          ease: "expoScale(0.5, 7, none)",
        },
        {
          at: "<",
        },
      ],
    ]).finished;
  }

  document.documentElement.classList.remove("js-menu-active");
  siteMenuTrigger.classList.remove("pointer-events-none");
};

export default {
  init: () => {
    const scrollPixel = document.querySelector(".scroll-pixel");

    if (scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    on("click", ".site-menu-trigger", (e) => {
      const trigger = e.currentTarget;

      if (trigger.getAttribute("aria-expanded") === "true") {
        closeMenu();
      } else {
        openMenu();
      }
    });

    on("click", ".site-menu", (e) => {
      if (!e.target.closest(".site-menu-wrapper")) {
        closeMenu();
      }
    });

    window.addEventListener("resize", () => {
      generateSiteMenuLinePath();
    });

    generateSiteMenuLinePath();
  },
};
